import { render, staticRenderFns } from "./MonitoramentoAgricola.vue?vue&type=template&id=f8ff5ace&scoped=true&lang=pug"
import script from "./MonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./MonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoAgricola.vue?vue&type=style&index=0&id=f8ff5ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ff5ace",
  null
  
)

export default component.exports